module.exports = __webpack_public_path__ + "media/סיר.a807dd52.mp3";